(function(){
	'use strict';
	angular.module('app.leanProjects')
		.controller('goalPerformance', goalPerformance);

	goalPerformance.$inject = ['$scope', '$timeout', 'leanFilterService', 'tableRenderService', 'tableService', '$experiments', 'storeService', '$state'];

	function goalPerformance($scope, $timeout, leanFilterService, tableRenderService, tableService, $experiments, storeService, $state) {
		var vm = this;
		var reportSettingsName = 'goal-performance';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {};
		// Extra drilldown query params to parse
		var extraFilters = [];
		var pinnedColumns = [];
		var defaultFilters = [];
		var unsubscribe;
		$scope.filterService = leanFilterService;

		// Set navigation properties
		vm.showExcel = false;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Goal performance (Lean projects)';

		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.baseReportDisplay = vm.reportName;

		if (reportSettingsId) {
			vm.showInfo = true;
		} else {
			vm.showSaveReport = true;
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		init();

		var columns = [
			{
				id: 'goalName',
				display: 'Goal Name',
				width: 360
			},
			{
				id: 'totalProjects',
				customHeaderClass: 'table-header-1',
				display: 'Projects: Total',
				ndxField: 'goalNdx',
				renderer: tableRenderService.integerWithLink,
				width: 120,
				urlGenerator: urlGenerator
			},
			{
				id: 'completedProjects',
				customHeaderClass: 'table-header-1',
				display: 'Projects: Completed',
				renderer: tableRenderService.integer,
				width: 120
			},
			{
				id: 'percentProjectsCompleted',
				customHeaderClass: 'table-header-1',
				display: 'Projects: Percent Complete',
				renderer: tableRenderService.percent,
				width: 120
			},
			{
				id: 'totalTasks',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Total',
				ndxField: 'goalNdx',
				renderer: tableRenderService.integerWithLink,
				width: 120,
				urlGenerator: urlGenerator
			},
			{
				id: 'completedTasks',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Completed',
				renderer: tableRenderService.integer,
				width: 120
			},
			{
				id: 'percentTasksCompleted',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Percent Complete',
				renderer: tableRenderService.percent,
				width: 120
			}
		];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/LeanProject/GoalPerformance',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'goalName',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			hideSearch: true,
			hideEdit: true,
			setColumnDefaults: true,
			hideFileters: true
		};

		function urlGenerator(type, ndx, factoryNdxs) {
			var url = '';
			if (type === 'totalProjects') {
				url = '/application/f/home.html#/lean-projects/projects-kanban/?drilldown=1&projectGoalId=' + ndx + '&factory=' + factoryNdxs;
			} else if (type === 'totalTasks') {
				url =  '/application/f/home.html#/lean-projects/view-tasks/?drilldown=1&projectGoalId=' + ndx + '&factory=' + factoryNdxs;
			}
			return url;
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			defaultFilters = [
				{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }
			];
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);
			$scope.filterService.setMasterFilterList([siteFilter]);
			$scope.filterService.setMasterSingleSelectFilterList([]);
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;

				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});

		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();